"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bracelet__on__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bracelet_on_dark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16,96A32.06,32.06,0,0,1,48,64H144a32,32,0,1,1,0,64H48A32.06,32.06,0,0,1,16,96Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,126H48A32,32,0,0,1,16,95c0,.34,0,.67,0,1a32.06,32.06,0,0,0,32,32H144a32.05,32.05,0,0,0,32-32c0-.33,0-.66,0-1A32,32,0,0,1,144,126Z",
    style: {
      opacity: 0.06
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,96a36,36,0,1,1,36,36A36,36,0,0,1,104,96Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,96a36,36,0,1,1,36,36A36,36,0,0,1,104,96Z",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,130a36,36,0,0,1-36-35c0,.33,0,.65,0,1a36,36,0,1,0,72,0c0-.33,0-.65,0-1A36,36,0,0,1,140,130Z",
    style: {
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "154.89 85.96 134.89 105.96 125.11 96.18",
    style: {
      fill: "none",
      stroke: "#f4f4f4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 4
    }
  }));
}

var _default = ic_bracelet__on__dark;
exports.default = _default;